export default "__VITE_ASSET__b$0OhsR7__"